import { Control, Controller, FieldValues, Path } from 'react-hook-form';
import { TextField, TextFieldProps } from '@mui/material';

interface FormTextFieldProps<T extends FieldValues> extends Omit<TextFieldProps, 'name'> {
  name: Path<T>;
  control: Control<T, any, any>;
  testId?: string;
}

export const FormTextField = <T extends FieldValues>({
  name,
  control,
  testId,
  ...textFieldProps
}: FormTextFieldProps<T>) => {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <TextField
          {...field}
          {...textFieldProps}
          error={!!error}
          helperText={error?.message}
          size="small"
          slotProps={{
            htmlInput: {
              'data-testid': testId,
              'data-rhf-field': String(name),
            },
          }}
        />
      )}
    />
  );
};
